export default __webpack_public_path__ + "static/media/68.0878576c.gif";